import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Header from "./Header";
import { useParams } from "react-router-dom";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import "react-medium-image-zoom/dist/styles.css";
import "swiper/css";
import "swiper/css/free-mode";

export default function Size() {
  let server_url = localStorage.getItem("server_url");
  let { series_id } = useParams();

  const [size, setSize] = useState([]);

  useEffect(() => {
    getSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSize = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(`${server_url}size.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setSize(res.data.result);
      } else {
        setSize([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };

  
  return (
    <React.Fragment>
      <Header />
      <br />
      <br />
      <br />
      <div className="page-content">
        <div className="page-content">
          <div className="row mb-0" style={{ padding: "0px 10px" }}>
            {size.map((sizee, index) => (
              <Link
                to={{
                  pathname: "/Products/" + sizee.size_id + '/' + series_id,
                  state: { stateParam: true },
                }}
                key={index}
                className="col-6 pe-0"
                style={{ padding: "0px", marginTop: "10px" }}
              >
                <div
                  className="card card-style"
                  style={{
                    margin: '0px 10px 0px 10px',
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div className="p-2">
                    <h4
                      className="mb-0"
                      style={{ lineHeight: "50px", fontSize: "30px" }}
                    >
                      <center>{sizee.size_name}</center>
                    </h4>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        <Footer />
      </div>
    </React.Fragment>
  );
}
